import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 傳入值
 */
export interface JobAssetInvestmentPostBackReq {
    base64Data: string;
}
/**
 * @todo Api 回傳值
 */
export interface JobAssetInvestmentPostBackResp extends GeneralResp {}

/**
 * @todo 填寫基本資料
 */
const JobAssetInvestmentPostBack = (data: JobAssetInvestmentPostBackReq): Promise<JobAssetInvestmentPostBackResp> => {
    const url = RouteUrlList.API_JobAssetInvestmentPostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<JobAssetInvestmentPostBackResp>) => {
        return res.data;
    });
};

export default JobAssetInvestmentPostBack;
